<template>
  <div class="product-root py-16">
    <div class="max-w-7xl mx-auto mb-24">
      <PlatformFeatures />
    </div>
    <Ribbon v-bind="ribbonData" class="mb-8" to="/schedule-call" />
    <div class="container mx-auto mb-8">
      <SplashRealTime />
    </div>
    <Ribbon v-bind="ribbonData" variant="gray" to="/schedule-call" />
    <div class="container mx-auto py-16 mb-12">
      <SplashEmployeeVoices />
    </div>
  </div>
</template>

<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import PlatformFeatures from '@/modules/InformationPages/Product/components/PlatformFeatures.vue';
import Ribbon from '@/components/Ribbon.vue';
import SplashRealTime from '@/modules/InformationPages/Product/components/SplashRealTime';
import SplashEmployeeVoices from '@/modules/InformationPages/Product/components/SplashEmployeeVoices';
import useGlobalSettings from '@/hooks/useGlobalSettings';

export default defineComponent({
  name: 'ProductRoot',
  components: {
    PlatformFeatures,
    Ribbon,
    SplashEmployeeVoices,
    SplashRealTime,
  },
  setup() {
    const ribbonData = {
      title: 'Schedule an Overview Call',
      subtitle: 'Learn how Bambee can help your business',
      cta: 'Schedule Overview Call',
    };
    const { setHeader } = useGlobalSettings();

    setHeader({
      header: `Products and Features`,
      subheader: null,
      heroImage: null,
      metaTitle: `Complete HR Solution Software | Bambee`,
      registration: false,
      noHero: false,
    });

    const { title, meta } = useMeta();

    title.value = `Complete HR Solution Software | Bambee`;

    meta.value = [
      { property: 'fb:app_id', content: '1048426768539865' },
      { property: 'og:type', content: 'website' },
      {
        hid: 'og:title',
        property: 'og:title',
        content: `Complete HR Solution Software | Bambee`,
      },
    ];

    return {
      ribbonData,
    };
  },
  head() {},
});
</script>
